var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 20,
    viewBox: "0 0 67 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69464 17.058C5.09964 17.1788 1.79364 17.2175 1.32964 16.4055C0.749638 15.3905 -0.192862 9.66297 6.69464 7.41547C12.2046 5.61747 19.1888 5.45797 21.9921 5.60297C24.8196 3.57299 32.4756 -0.341974 40.4796 0.238026C48.4836 0.818026 55.4629 3.57299 57.9521 4.87797C59.5229 4.6363 62.8241 4.29797 63.4621 4.87797C64.1001 5.45797 65.5646 8.74464 66.2171 10.3155C66.4587 11.8138 66.5941 14.97 65.2021 15.608C63.8101 16.246 60.2237 16.4055 58.6046 16.4055L58.3551 16.4086C58.5181 15.8807 58.6058 15.3198 58.6058 14.7385C58.6058 11.6153 56.074 9.08346 52.9508 9.08346C49.8276 9.08346 47.2958 11.6153 47.2958 14.7385C47.2958 15.3698 47.3992 15.9769 47.5901 16.5439L17.5704 16.9213C17.8517 16.2496 18.0071 15.5122 18.0071 14.7385C18.0071 11.6153 15.4753 9.08346 12.3521 9.08346C9.22893 9.08346 6.6971 11.6153 6.6971 14.7385C6.6971 15.5626 6.87341 16.3456 7.19036 17.0517L6.69464 17.058ZM25.7621 5.60336C27.1879 4.37086 33.1426 1.54336 39.7546 1.54336C46.3666 1.54336 49.9529 3.33169 50.9196 4.22586L50.5571 5.60336H25.7621Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.277,
    cy: 14.521,
    r: 3.915,
    stroke: "#BABABA",
    strokeWidth: 1.595
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.023,
    cy: 14.521,
    r: 3.915,
    stroke: "#BABABA",
    strokeWidth: 1.595
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupe);
export default ForwardRef;